import React from 'react';
import {
    MenuItemLink,
    WithPermission
} from 'admin-on-rest';
import {hasSystemAccess, resolveAccess} from '../shared/authFunctions';
import LogoutButton from '../buttons/LogoutButton';

import HomeIcon from 'material-ui/svg-icons/action/home';
import CombinedSalesReportsIcon from 'material-ui/svg-icons/editor/pie-chart';
import CreditCardTransactionIcon from 'material-ui/svg-icons/action/credit-card';
import DailySalesReportsIcon from 'material-ui/svg-icons/action/date-range';
import DetailedSalesReportsIcon from 'material-ui/svg-icons/action/receipt';
import DiscountsReports from 'material-ui/svg-icons/action/receipt';
import InventoryLogReportsIcon from 'material-ui/svg-icons/action/description';
import InventoryTransferLookupReportsIcon from 'material-ui/svg-icons/maps/local-shipping';
import ItemSalesReportsIcon from 'material-ui/svg-icons/editor/monetization-on';
import LocationRegisterLogReportsIcon from 'material-ui/svg-icons/action/description';
import PreSettlementReportsIcon from 'material-ui/svg-icons/editor/insert-chart';
import SalesComparisonReportsIcon from 'material-ui/svg-icons/action/compare-arrows';
import SalesLogReportsIcon from 'material-ui/svg-icons/action/description';
import SalesSummaryReportsIcon from 'material-ui/svg-icons/editor/pie-chart';
import SalesTaxAuditReportsIcon from 'material-ui/svg-icons/maps/local-atm';
import SettlementReportsIcon from 'material-ui/svg-icons/editor/insert-chart';
import TransactionLogReportsIcon from 'material-ui/svg-icons/action/description';
import VIPSignupsReportsIcon from 'material-ui/svg-icons/action/card-membership';
import VIPTrendsReportsIcon from 'material-ui/svg-icons/action/card-membership';
import InventoryOrdersIcon from 'material-ui/svg-icons/action/today';
import ReportJobsIcon from 'material-ui/svg-icons/action/work';
import ScheduledReportsIcon from 'material-ui/svg-icons/action/schedule';

const textWrap = (first, second) => {
    const styles = {
        first: {
            display: 'block',
        },
        second: {
            display: 'block',
            lineHeight: 1,
            margin: '-5px 0 0 0',
            paddingBottom: '10px'
        }
    };
    return (
        <span>
            <span style={styles.first}>{first}</span>
            <span style={styles.second}>{second}</span>
        </span>
    )
};

/**
 * The Sidebar Menu displays links based on User permission.
 *
 * @param onMenuTap
 * @return {*}
 * @constructor
 */
export const MainMenu = ({onMenuTap}) => {
    return (
        <div className="menu-links">
            <MenuItemLink to="/" primaryText="Dashboard" leftIcon={<HomeIcon/>} onClick={onMenuTap}
                          className="menu-link"/>

            <WithPermission resolve={(props) => resolveAccess(props.permissions)}>
                <MenuItemLink to="/CombinedSalesReports" primaryText="Combined Sales"
                              leftIcon={<CombinedSalesReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            {/* Sales Resources  */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions, ['reports_sales'])}>
                <MenuItemLink to="/SalesSummaryReports" primaryText="Sales Summary"
                              leftIcon={<SalesSummaryReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/DailySalesReports" primaryText="Daily Sales"
                              leftIcon={<DailySalesReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/DetailedSalesReports" primaryText="Detailed Sales"
                              leftIcon={<DetailedSalesReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/DiscountsReports" primaryText="Discounts Reports"
                              leftIcon={<DiscountsReports/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/ItemSalesReports" primaryText="Item Sales"
                              leftIcon={<ItemSalesReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/SalesTaxAuditReports" primaryText="Sales Tax Audit"
                              leftIcon={<SalesTaxAuditReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/SalesComparisonReports" primaryText="Sales Comparison"
                              leftIcon={<SalesComparisonReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/PreSettlementReports" primaryText="Pre-Settlement Reports"
                              leftIcon={<PreSettlementReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/SettlementReports" primaryText="Settlement Reports"
                              leftIcon={<SettlementReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            {/* Inventory Resources  */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions, ['reports_inventory'])}>
                <MenuItemLink to="/InventoryTransferLookupReports"
                              primaryText={textWrap('Inventory Transfer', 'Lookup')}
                              leftIcon={<InventoryTransferLookupReportsIcon/>} onClick={onMenuTap}
                              className="menu-link"/>
            </WithPermission>

            {/* Configuration Resources  */}

            {/* Other Resources  */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions)}>
                <MenuItemLink to="/InventoryLogReports" primaryText="Inventory Log"
                              leftIcon={<InventoryLogReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/TransactionLogReports" primaryText="Transaction Log"
                              leftIcon={<TransactionLogReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/SalesLogReports" primaryText="Sales Log"
                              leftIcon={<SalesLogReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/LocationRegisterLogReports" primaryText="Location/Register Log"
                              leftIcon={<LocationRegisterLogReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
                <MenuItemLink to="/CreditCardTransactionReports"
                              primaryText={textWrap('Credit Card', 'Transaction Search')}
                              leftIcon={<CreditCardTransactionIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            {/* Loyalty Resources; VIP Signups  */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions, [], [], ['vip_signups'])}>
                <MenuItemLink to="/VIPSignupsReports" primaryText="VIP Signups"
                              leftIcon={<VIPSignupsReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            {/* Loyalty Resources; VIP Trends  */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions)}>
                <MenuItemLink to="/VIPTrendsReports" primaryText="VIP Trends"
                              leftIcon={<VIPTrendsReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            {/* Scheduled Report Resources  */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions, [], [], ['schedule_reports'])}>
                <MenuItemLink to="/ScheduledReports" primaryText="Scheduled Reports"
                              leftIcon={<ScheduledReportsIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            {/* Report Jobs Resources  */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions, [], [], ['jobs'])}>
                <MenuItemLink to="/ReportJobs" primaryText="Report Jobs"
                              leftIcon={<ReportJobsIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            {/* Inventory Orders Resources  */}
            {hasSystemAccess('jakes') &&
                <WithPermission resolve={(props) => resolveAccess(props.permissions, [], [], ['inventory_orders'])}>
                    <MenuItemLink to="/InventoryOrders" primaryText="Inventory Orders"
                                  leftIcon={<InventoryOrdersIcon/>} onClick={onMenuTap} className="menu-link"/>
                </WithPermission>
            }

            <LogoutButton/>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/Fuse/global/menu.js